<template>
  <div :class="['hotels-result-content',{'fixed-filter': fixedFilters}, `list-${listType}`]">

    <transition name="alert">
      <div v-show="outSistemLoad" class="out-sistem-wrap">
        <h3 class="out-sistem-title mr-10">{{ localizeList.searchingToursWithRemoteHotels }}</h3>
        <base-loader color="var(--dark-1-color)" size="20" weight="6"/>
      </div>
    </transition>

    <country-info v-show="listType !== 'grid' && tourResultList.length" />

    <div class="empty-result" v-if="!getWindowSettings.commonFiltersForHotels && !tourResultList.length && !outSistemLoad">
      <p>
        {{ localizeList.noToursFound }}
      </p>
    </div>

    <div class="empty-result" v-else-if="getWindowSettings.commonFiltersForHotels 
    && !tourResultList.length && !outSistemLoad 
    && !getShowTourResultList && !checkUsageCommonSearch 
    && getSearchSecondParamsCounter < 2 && !getSearchLoaderStatus">
      <p>
        {{ localizeList.noToursFound }}
      </p>
    </div>

    <div class="result-wrap">
      <div :class="['list-group', {'map-mode': listType === 'map'}]">

        <!-- Карта -->
        <map-result v-if="listType === 'map' && tourResultList.length"
                    @buyTour="buyTourMinPriceAndHotelSchem($event, 0)"
                    :rate="rate"
                    :focused="focusedMapItem"
                    :mapItems="mapItems"
                    :has-country-info="hasCountryInfo"
                    :out-sistem-load="outSistemLoad"/>


        <base-button v-if="listType === 'map' && tourResultList.length"
                     @click.native="toggleResults()"
                     :class="['collapse-result-btn', {'rotate': !showMapResults}]"
                     background="var(--white-color)">
          <icon name="angle" width="24px" height="24px" fill="var(--lighten-5-color)"/>
        </base-button>

        <div v-show="showMapResults && getShowTourResultList">
          <!--Результаты поиска списком(big) -->
          <big-row-result v-if="listType === 'big-row'"
                          :rate="rate"
                          :key="rowResultKey"
                          :c-o-info="COInfo"
                          :tour-result-list="tourResultList"
                          :buy-list="buyList"
                          :buy-list-show="buyListShow"
                          :slider-default-image="sliderDefaultImage"
                          :slider-default-image-count="sliderDefaultImageCount"
                          :tour-all-images="tourAllImages"
                          :buy-list-not-hotel-key="buyListNotHotelKeyForBigRow"
                          @resetBuyListNotHotelKey="buyListNotHotelKeyForBigRow = null"
                          @leaveList="leaveList($event)"
                          @hoverList="hoverList($event)"
                          @serviceClick="serviceClick($event)"
                          @rightModalAviaFlight="rightModalAviaFlight($event)"
                          @buyTour="buyTour(...$event)"
                          @toggleBuyList="toggleBuyList(...$event)"
                          @rightModalHotelInfo="rightModalHotelInfo(...$event)"
                          @rightModalHotelOrTourInfo="rightModalHotelOrTourInfo(...$event)"
                          @rightModalBooking="rightModalBooking(...$event)" />

          <!--Результаты поиска сеткой (Показывается и при карте) ' || listType === 'map'-->
          <card-result :rate="rate"
                       :c-o-info="COInfo"
                       :tour-result-list="tourResultList"
                       :slider-default-image="sliderDefaultImage"
                       :slider-default-image-count="sliderDefaultImageCount"
                       :tour-all-images="tourAllImages"
                       :buy-list="buyList"
                       :buy-list-show="buyListShow"
                       :list-type="listType"
                       :buy-list-not-hotel-key="buyListNotHotelKeyForCard"
                       @resetBuyListNotHotelKey="buyListNotHotelKeyForCard = null"
                       @leaveList="leaveList($event)"
                       @hoverList="hoverList($event)"
                       @serviceClick="serviceClick($event)"
                       @rightModalAviaFlight="rightModalAviaFlight($event)"
                       @buyTour="buyTour(...$event)"
                       @toggleBuyList="toggleBuyList(...$event)"
                       @rightModalHotelInfo="rightModalHotelInfo(...$event)"
                       @rightModalHotelOrTourInfo="rightModalHotelOrTourInfo(...$event)"
                       @rightModalBooking="rightModalBooking(...$event)"/>

          <!--Лоадер(появляется при прокрутки в самый низ)-->
          <template v-if="listType === 'map' && !hiddenResult && getShowTourResultList">
            <circle-loader :show="moreResultLoader" class="more-result-loader"/>
            <div v-show="showLoadMoreBtn" class="load-more-btn">
              <base-button @click.native="loadMore()">{{localizeList.loadMore}}</base-button>
            </div>
          </template>
        </div>
      </div>

      <!--Результаты поиска списком -->
      <row-result v-if="listType === 'row' && getShowTourResultList"
                  :rate="rate"
                  :key="rowResultKey"
                  :c-o-info="COInfo"
                  :tour-result-list="tourResultList"
                  :buy-list="buyList"
                  :buy-list-show="buyListShow"
                  :slider-default-image="sliderDefaultImage"
                  :hotel-default-images="sliderDefaultImageForRowResult"
                  :buy-list-not-hotel-key="buyListNotHotelKeyForRow"
                  @resetBuyListNotHotelKey="buyListNotHotelKeyForRow = null"
                  @leaveList="leaveList($event)"
                  @hoverList="hoverList($event)"
                  @serviceClick="serviceClick($event)"
                  @rightModalAviaFlight="rightModalAviaFlight($event)"
                  @buyTour="buyTour(...$event)"
                  @toggleBuyList="toggleBuyList(...$event)"
                  @rightModalHotelInfo="rightModalHotelInfo(...$event)"
                  @rightModalBooking="rightModalBooking(...$event)" />
    </div>

    <!--Модальное окно(появляется справо)-->
    <right-modal :show="showRightModal"
                 :class="{'booking': rigthModalType === 'tourBooking'}"
                 @toggle="showRightModal = $event">
      <div v-if="rigthModalType === 'tourBooking'" class="tour-booking">
        <h3 class="tour-booking-name mb-7">{{ selectedTourName }}</h3>

        <h5 class="tour-booking-headline">{{ localizeList.tourBookingConditions }}</h5>

        <large-slider v-show="tourImages.length"
                      class="mb-10 pb-4"
                      :images="tourImages"
                      :images-description="tourImagesDescription" />

        <p v-html="tourBookingHTML"></p>
      </div>

      <!--Иформация о отеле-->
      <div v-else-if="rigthModalType === 'hotelInfo'" class="tour-hotel-info">
        <div class="hotel-info-header mb-8">
          <div class="hotel-info-header-block hotel-info-header-title">
            <div class="hotel-name-wrap flex">
                <h3 class="hotel-name">
                  <a v-if="hotelInfo.http" :href="hotelInfo.http" target="_blank">
                    {{ getHotelName(hotelInfo.data, true) }}
                    {{ typeof getHotelStars(hotelInfo.data, true) === "string" ? getHotelStars(hotelInfo.data, true) : "" }}
                  </a>
                  <span v-else>
                                      {{ getHotelName(hotelInfo.data, true) }}
                                      {{ typeof getHotelStars(hotelInfo.data, true) === "string" ? getHotelStars(hotelInfo.data, true) : "" }}
                                  </span>
                </h3>
                <div v-if="typeof getHotelStars(hotelInfo.data, true) === 'number'" class="hotel-stars flex">
                  <div v-for="(item, key) in getHotelStars(hotelInfo.data, true)" :key="key">
                    <icon name="star" width="14px" height="14px" fill="var(--yellow-color)"/>
                  </div>
                </div>
            </div>

            <div class="place align-center">
                <svg class="mr-6" width="14px" height="14px" fill="var(--lighten-7-color)">
                  <use xlink:href="../../../assets/images/sprite.svg#map-icon"></use>
                </svg>
                <p class="ligth-grey-text-small">
                  {{ getHotelCity(hotelInfo.data, true) }},
                  {{ getHotelCountry(hotelInfo.data, true) }}
                </p>
                <p class="ligth-grey-text-small hotel-time-info">
                  {{ getHotelTimeInfo() }}
                </p>
            </div>
          </div>

          <div class="hotel-info-header-block hotel-info-header-price">
            <div class="hotel-price">
                {{ localizeList.fromPrice }} {{ hotelInfo.data.Cost|correctPrice }} {{ getCurrencyDisplayBySettings(rate) }}
            </div>

            <div @click="changeHotelInfoNavbar(-1)"
                  :class="['blue-text-small pointer',{'text-focus': hotelInfo.activeItem === null}]">
                {{ localizeList.variants }}
            </div>
          </div>

          <pdf-generate-button v-if="hotelInfo" :hotel="hotelInfo" />
        </div>

        <!--Навигация по информации отеля-->
        <div class="hotel-info-navbar flex mb-8 align-center">
          <div v-for="(item, key) in hotelInfo.nav"
               :key="key"
               @click="changeHotelInfoNavbar(key)"
               :class="['nav-item', 'mr-8', {'active': hotelInfo.activeItem === key}]">
            {{ item }}
          </div>
        </div>
        <div ref="hotelInfoContent" class="hotel-info-content">

          <!--Слидер скартинками отеля-->
          <div class="hotel-info-slider">
            <large-slider class="mb-4"
                          type="Hotel"
                          :images="hotelInfo.images"
                          :images-description="hotelInfo.imagesDescription" />

            <div class="hotel-features">
              <div v-for="(item, key) in getHotelType(hotelInfo.data, true)"
                   :key="key"
                   class="hotel-features-item align-center">
                <img width="20px" height="20px" :src="getHotelTypeIcon(item.Key)"
                     class="hotel-type-icon mr-8"/>
                <p class="dark-small-text">{{ item.Value }}</p>
              </div>
            </div>
          </div>

          <div v-for="(item, key) in hotelInfo.moreInfo"
               :key="key"
               ref="hotelInfoItem"
               class="hotel-info-content-item">
            <h4 :class="['dark-big-text',{'active': hotelInfo.activeItem === key + 1}]" >{{ item.title }}</h4>
            <div v-if="item.isContact">
              <template v-if="!settings.DoNotShowHotelDetails">
                <p v-if="item.address">
                  {{ localizeList.addressUpper }}: {{ item.address }}
                </p>
                <p v-if="item.phone">
                  {{ localizeList.phoneNumberUpper }}: {{ item.phone }}
                </p>
                <p v-if="item.email">
                  Почта: {{ item.email }}
                </p>
              </template>
              <template v-else>
                <p>
                  {{ localizeList.addressUpper }}:
                  {{ getHotelCity(hotelInfo.data, true) }},
                  {{ getHotelCountry(hotelInfo.data, true) }}
                </p>
              </template>
              <div v-if="hotelInfo.http" class="mt-4 mb-4">
                <a :href="hotelInfo.http" class="blue-text" target="_blank">{{localizeList.addHotelInformation}}</a>
              </div>
              <div v-if="hotelInfo.data.coordinates || checkHotelInfoForCoord"
                   ref="hotelMap"
                   class="hotel-info-map-wrap mt-4"
                   style="height: 400px">
                <hotels-map @buyTour="buyTourMinPriceAndHotelSchem($event, 0)"
                          show-only-selected
                          :rate="rate"
                          :number="2"
                          :focused="focusedMapItemInHotelInfo"
                          :focusedInListView="focusedMapHotelInListView"
                          :mapItems="getSelectedMapItem"/>
              </div>
            </div>
            <div v-else v-html="item.value" class="word-break"></div>
          </div>
          <div ref="hotelVariants" class="hotel-info-content-item">
            <h4 :class="['dark-big-text', {'active': hotelInfo.activeItem === -1}]">{{ localizeList.accommodationOptions }}</h4>
            <div v-for="(item2, key2) in buyList[hotelInfo.key]"
                 :key="key2"
                 class="tour-program-item-group">
              <div v-for="(item3, key3) in item2.items"
                   :key="key3"
                   class="tour-program-item"
                   :class="{ 'tour-program-qui-quo-item': getWindowSettings.showQuiQuoService }"
                   >
                <div class="left-block align-center">
                    <div class="mr-8"
                         @mouseleave="hidePopover()"
                         @mouseenter="showPopover(getQuotaText(item3, 3), $event)">
                        <icon v-if="getBuyIconStatus(item3) === 'aviailable'"
                              name="aviailable" width="16px" height="16px" />
                        <icon v-else-if="getBuyIconStatus(item3) === 'less'"
                              name="less" width="16px" height="16px" />
                        <icon v-else-if="getBuyIconStatus(item3) === 'not-aviailable'"
                              name="not-aviailable" width="16px" height="16px" />
                        <icon v-else name="request" width="16px" height="16px" />
                    </div>

                    <div v-if="isMultiHotels(hotelInfo)" class="info-content-multi-hotels">
                      <div class="info-content-link">
                        <p class="standard-text-small mr-2 link-text" @click="rightModalHotelInfo(hotelInfo.data, hotelInfo.key, key3)">
                          {{hotelInfo.data.hotels[key3].City.Value}}
    <!--                      {{item2.allData.RouteSubVariants[0].Services[key3].City.Value}}-->
                          /
                          {{hotelInfo.data.hotels[key3].Hotel.Value}}
                        </p>
                        <span v-if="!getStars(hotelInfo.data.hotels[key3].Stars.Value)"
                        class="standard-text-small category-string">
                        {{ typeof getHotelStars(hotelInfo.data.hotels[key3].Stars.Value, false, true) === "string" ? getHotelStars(hotelInfo.data.hotels[key3].Stars.Value, false, true) : "" }}
                        </span>
                        <div v-else class="flex">
                            <div
                              v-for="(item4, key4) in getStars(hotelInfo.data.hotels[key3].Stars.Value)"
                              :key="key4">
                              <icon name="star" width="14px" height="14px" fill="var(--yellow-color)"/>
                            </div>
                        </div>
                      </div>
                      <p class="standard-text-small ml-2">
                        {{ item3.accomodationType + " / " + item3.roomCategory + " / " + item3.adult }}
                      </p>
                    </div>
                    <p v-else class="standard-text-small">
                        {{ item3.accomodationType + " / " + item3.roomCategory + " / " + item3.adult }}
                    </p>
                  </div>
                <div class="align-center justify-between">
                  <p class="tour-program-pansion grey-text-small ml-6">
                    {{
                      item3.pansion +
                      (item3.pansionAdditionalInfo != null ? " / " + item3.pansionAdditionalInfo : "")
                    }}
                    <span v-if="item3.hotelData.CriticalInfo"> / </span>
                    <span v-if="item3.hotelData.CriticalInfo" class="red-text">{{ localizeList[item3.hotelData.CriticalInfo] }}</span>
                  </p>
                  <!--                  <p class="grey-text-small">-->
                  <!--                    {{ item2.pansion }}-->
                  <!--                  </p>-->
                  <base-button :style="{'opacity': showBuyListPrice(item2.items, key3) ? 1 : 0, 'z-index': showBuyListPrice(item2.items, key3) ? 1 : -1}"
                               @click.native="buyTour(item2, key2)"
                               :background="focusHotelVariantBtn === key2 ? 'rgb(44 134 198)' : 'var(--primary-color)'"
                               class="ml-10 tour-program-list-btn"
                               padding="6px 8px">
                    <icon name="basket" width="16px" height="16px" fill="var(--white-color)"/>
                    <span class="font-small font-bold ml-3">{{ item2.cost|correctPrice }} {{ getCurrencyDisplayBySettings(rate) }}</span>
                  </base-button>
                </div>

                <div v-if="getWindowSettings.showQuiQuoService" class="qui-quo-actions" @click.stop>
                      <div class="qq-btn-place qui-quo-place" :data-value="getQuiQuoJSON(hotelInfo.data, item2, item3)">
                      </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!--Информация по авиа перелетам-->
      <avia-flight-info v-else-if="rigthModalType === 'aviaFlight'"
                        :avia-flight-info="aviaFlightInfo"/>

      <!--Информация по транспорту-->
      <transport-info v-else-if="rigthModalType === 'bus' || rigthModalType === 'railway' || rigthModalType === 'transfer'"
                      :type="rigthModalType"
                      :transport-info="transportInfo"/>

    </right-modal>

    <!--Кнопка вверх-->
    <page-up :show="showPageUp"/>

    <!--Лоадер(появляется при прокрутки в самый низ)-->
    <template v-if="listType !== 'map' && getShowTourResultList">
      <circle-loader :show="moreResultLoader" class="more-result-loader"/>
      <div v-show="showLoadMoreBtn" class="load-more-btn mt-10">
        <base-button @click.native="loadMore()">{{localizeList.loadMore}}</base-button>
      </div>
      <div v-if="!showLoadMoreBtn && !moreResultLoader" class="mt-10 mb-10"></div>
    </template>

    <auto-loader v-if="settings.AutomaticLoadingResults && getShowTourResultList"
                 @loadLocal="loadMoreLocalOrExternal(true, $event)"
                 @loadExternal="loadMoreLocalOrExternal(false, $event)"
                 :tour-result-list="tourResultList"
                 :list-type="listType"
                 :collapseByHotel="collapseByHotel"/>

  </div>
</template>

<script>
import Vue from 'vue'
import {bus} from '../../../main'
import moment from 'moment'

import pageUp from "../../baseComponents/pageUp";
import circleLoader from "../../baseComponents/circleLoader";
import aviaFlightInfo from "../serviceInfo/aviaFlightInfo";
import transportInfo from "../serviceInfo/transportInfo";
import hotelsMap from "../hotelsMap";

import * as mTypesHotels from "@/stores/modules/hotels/mutation_types"
import * as typesHotels from "@/stores/modules/hotels/types";
import * as typesGlobal from "@/stores/types";
import * as GTM from "@/plugins/GTM.js";
import CountryInfo from "./countryInfo";
import LargeSlider from "./LargeSlider";
import MapResult from "./mapResult";
import CardResult from "./cardResult";
import rowResult from "./rowResult";
import bigRowResult from "./bigRowResult";

import autoLoader from "./autoLoader";
import pdfGenerateButton from '@/views/common/pdf/pdfGenerateButton'

import {getArrayDifference} from '../../../plugins/methods'


export default {
  name: "tour-result-list",
  components: {
    autoLoader,
    bigRowResult,
    rowResult,
    CardResult,
    MapResult,
    LargeSlider,
    CountryInfo,
    aviaFlightInfo,
    transportInfo,
    circleLoader,
    hotelsMap,
    pageUp,
    pdfGenerateButton
  },
  props: {
    collapseByHotel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focusedMapHotelInListView: null,
      API_ORIGIN: this.$store.getters['getApiOrigin'],
      buyListShow: [],
      buyListHover: [],
      buyList: [],
      listType: 'grid',
      focusedMapItem: null,
      focusedMapItemInHotelInfo: null,
      showRightModal: false,
      rigthModalType: null,
      selectedTourName: "",
      tourBookingHTML: "",
      hotelInfo: {
        http: null,
        hotelIndex: 0,
        nav: [],
        activeItem: 0,
        data: {},
        key: null,
        images: [],
        sliderPosition: 0,
        moreInfo: [],
        imagesDescription: [],
        timeFrom: "",
        timeTo: "",
      },
      tourAllImages: [],
      tourImages: [],
      tourImagesDescription: [],
      focusHotelVariantBtn: null,
      aviaFlightInfo: {
        data: null,
        services: []
      },
      gtm: {
        firstLoad: false,
        impressionsCountLocal: 0,
        impressionsCountRemote: 0
      },
      resultPage: 1,
      moreResultLoader: false,
      loaderCount: 4,
      rowResultKey: 0,
      rate: {},
      stopLoadMoreResult: false,
      stopLoadMoreLocalResult: false,
      stopLoadMoreExternalResult: false,
      sliderDefaultImage: [],
      sliderDefaultImageForRowResult: [],
      sliderDefaultImageCount: [],
      isLong: [],
      outSistemLoad: false,
      cashTourResultList: null,
      COInfo: {},
      fixedFilters: false,
      showPageUp: false,
      maxFeaturesHeight: 0,
      transportInfo: [],
      hasCountryInfo: false,
      hiddenResult: false,
      showMapResults: true,
      clickBeforeScroll: false,
      hotelInfoScrollTimer: new Date().getTime(),
      buyListNotHotelKeyForCard: null,
      buyListNotHotelKeyForRow: null,
      buyListNotHotelKeyForBigRow: null,
    }
  },
  computed: {
    getSearchLoaderStatus() {
      return this.$store.getters['hotels/getSearchLoaderStatus']
    },
    getSearchSecondParamsCounter() {
      return this.$store.getters['hotels/getSearchSecondParamsCounter']
    },
    checkUsageCommonSearch () {
     return this.$store.getters['hotels/getCommonSearchFlag']
    },
    getWindowSettings() {
    return window.settings;
    },
    checkHotelInfoForCoord() {
      return this.hotelInfo.data.hotels.some(x => x.Latitude && x.Longitude)
    },
    getShowTourResultList() {
      return this.$store.getters['hotels/getShowTourResultList']
    },
    showLoadMoreBtn() {
      return !this.moreResultLoader && !this.stopLoadMoreResult && this.tourResultList.length >= 20 && !this.settings.AutomaticLoadingResults
    },
    settings() {
      const settings = this.$store.getters['getSettings'];
      return settings;
    },
    tourResultList() {
      let res = this.$store.getters['hotels/getSearchResult'];
      if (res.length === 0) {
        this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false)
      }
      const allHotels = [];
      res = res.map((x) => {
        const hotel = x.Services.find(x2 => x2.SvKey === 3);
        if (hotel && hotel.Latitude && hotel.Longitude) {
          x.coordinates = [
            parseFloat(hotel.Latitude),
            parseFloat(hotel.Longitude)
          ];
        }
        //Ишем отели
        x.hotels = x.Services.filter(x => x.SvKey === 3);
        x.showHotelsList = false;
        x.hoverHotelsList = false;
        allHotels.push(...x.hotels);

        //Правил ссылку
        x.TourUrl = this.correctUrl(x.TourUrl);

        return x
      });
      this.getCOInfo(allHotels);

      //res = this.getUniqueTours(res);

      // Сортировка по датам
      res = res.sort((a,b) => {
        return new Date(a.StartDate) - new Date(b.StartDate);
      });
      // Сортировка по продолжительности
      res = res.sort((a,b) => {
        return a.Duration < b.Duration ? -1 : (a.Duration > b.Duration ? 1 : 0)
      });
      // Сортировка по цене
      res = res.sort((a,b) => {
        return a.Cost < b.Cost ? -1 : (a.Cost > b.Cost ? 1 : 0)
      });
      return res;
    },
    mapItems() {
      const date = new Date().getTime();
      return this.$store.getters['hotels/getMapItems'].map((x) => {
        const hotel = x.Services.find(x2 => x2.SvKey === 3);
        if (hotel && hotel.Latitude && hotel.Longitude) {
          x.coordinates = [
            parseFloat(hotel.Latitude),
            parseFloat(hotel.Longitude)
          ];
        }

        x.update = date;
        return x
      });
    },
    flightInfoStartDate() {
      return moment(this.aviaFlightInfo.data.StartDate).format("DD MMM")
    },
    getSelectedMapItem() {
      if (!this.focusedMapItemInHotelInfo) {
        return this.mapItems
      }

      const item = this.mapItems.find(x => {
        return x.Services.some(x2 => {
          return parseFloat(x2?.Latitude) === this.focusedMapItemInHotelInfo.coordinates?.[0] &&
          parseFloat(x2?.Longitude) === this.focusedMapItemInHotelInfo.coordinates?.[1]
        })
      });

      if (item) {
        item.Cost = this.hotelInfo.data.Cost;
      }

      return [item]
    },
  },
  created() {
    bus.$on("hotels_toggle-map", (val) => {
      this.hiddenResult = val
    });
    bus.$on("searched-for-hotels", () => {
      this.resultPage = 1;
      this.outSistemLoad = false;
      this.stopLoadMoreLocalResult = false;
      this.stopLoadMoreExternalResult = false;
    });
    bus.$on("hotels-start-search", () => {
      this.gtm.firstLoad = false;
      this.gtm.impressionsCountLocal = 0;
      this.gtm.impressionsCountRemote = 0;
    });
    bus.$on("hotels_second_filters_start_search", () => {
      this.gtm.firstLoad = false;
      this.gtm.impressionsCountLocal = 0;
      this.gtm.impressionsCountRemote = 0;
    });
    bus.$on("toggle-up-btn", val => {
      this.showPageUp = val;
    });
    bus.$on("fixed-filters", val => {
      this.fixedFilters = val;
    });
    bus.$on("hotels-out-sistem-load", val => {
      this.$nextTick(() => {
        this.outSistemLoad = val;
      })
    });
    bus.$on("changeCurrency", () => {
      this.stopLoadMoreResult = false;
      this.resultPage = 1;
    });
    bus.$on("changeListType-for-hotels", type => {
      this.showMapResults = true;
      this.listType = type;
      this.setCollapseBtnTop();
      // this.setFeaturesMaxHeight();
    });
    bus.$on("country-info-for-hotels", countryInfo => {
      this.hasCountryInfo = !!countryInfo.length
    });


    window.addEventListener("click", this.windowClick);
    window.addEventListener("mouseup", this.stopDragSecondSlider);
    window.addEventListener("keydown", this.keydown);
  },
  mounted() {
    if (this.$store.getters['hotels/getSearchResult'] && this.$store.getters['hotels/getSearchResult'].length) {
      this.rate = this.$store.getters['hotels/getSearchResult'][0].rate
    }
    let listType = sessionStorage.getItem("listType");
    if (listType) {
      this.listType = listType;
    }

    this.setCollapseBtnTop()
  },
  methods: {
    getQuiQuoJSON(item, item2, item3) {
      const getTourDataQuiQuo = window.settings.getTourDataQuiQuo;
      const tourUrl = item.TourUrl;
      const tourName = item.Name;

      const startDate = item.StartDate.split('T')[0];
      const [year, month, day] = startDate.split('-') 
      const beginDate = `${day}.${month}.${year}`

      const { adult, childs, childAges } = this.getAdultAndChildsFromHref()

      const { names, countries, city, resort, hotelUrl } = this.getHotelQuiQuoData(item.hotels)

      const roomInfo = item3.accomodationType + " / " + item3.roomCategory + " / " + item3.adult;
      const cityAndResortString = resort ? `${city}, ${resort}` : city

      const name = getTourDataQuiQuo ? tourName : names;
      const href = getTourDataQuiQuo ? tourUrl : hotelUrl;

      let imageUrl;
      const tourKey = item.Key
      const hotelKey = item.hotels[0].Hotel.Key
      const isTourImage = this.sliderDefaultImage.find(x => x.includes(`code=${tourKey}`))
      const isHotelImage = this.sliderDefaultImage.find(x => x.includes(`code=${hotelKey}`))
      if (getTourDataQuiQuo && isTourImage) {
        imageUrl = isTourImage
      } else if (!getTourDataQuiQuo && !isHotelImage) {
        imageUrl = isTourImage
      } else {
        imageUrl = isHotelImage
      }

      const QuiQuoObject = {
        checkinDt: beginDate,
        nights: String(item.DurationInNight),
        hotelName: name,
        roomType: roomInfo,  
        boardType: item3.pansion,
        price: item2.cost,
        currency: item.rate?.IsoCode || this.getCurrencyFromHref(),
        city_from: item.CityDepature.Value,
        occupancy: {
          adultsCount: parseInt(adult),
          childrenCount: childs || 0,
          childAges: childAges || 0,
        },
        region: cityAndResortString,
        country: countries,
        thumbnail: imageUrl || "",
        href
      }

      return JSON.stringify(QuiQuoObject)
    },
    getCurrencyFromHref(){
      let currency;
      location.href.split('&').forEach(x => {
        if (x.includes('currency')) {
          currency = x.split('=')[1]
        }
      });
      return currency
    },
    getAdultAndChildsFromHref(){
      let adult = null;
      let childs = null;
      let childAges = null;

      location.href.split('&').forEach(x => {
        if (x.includes('adultCount')) {
          adult = x.split('=')[1]
        }
        if (x.includes('childAges')) {
          childAges = x.split('=')[1]
        }
        if (x.includes('childAges')) {
          childs = x.split('=')[1].split(',').length
        }
      });

      return {
        adult,
        childs,
        childAges
      }
    },
    getHotelQuiQuoData(hotels){
      const names = hotels.map(item => item.Hotel.Value).join(", ")
      const hotelUrl = hotels[0].Http
      const countries = hotels[0].Country.Value
      const city = hotels[0].City.Value
      const resort = hotels[0].Resort.Value
      const rooms = hotels.map(item => {
          return item.HotelDetails.map(subitem => subitem.Room.Value).join(', ')
      }).join(', ')

      return { names, countries, city, resort, rooms, hotelUrl }
    },
    isMultiHotels(info) {
      return info.data.hotels && info.data.hotels.length > 1
    },
    correctUrl(url) {
      if (!url || url.includes("http://") || url.includes("https://")) return url;
      return "http://www" + url.split("www")[1];
    },
    toggleResults() {
      this.showMapResults = !this.showMapResults;
    },
    async setCollapseBtnTop() {
      await this.$nextTick();

      const collapseBtn = document.querySelector(".collapse-result-btn");
      if (!collapseBtn) return;

      const mainFilters = document.querySelector("#main-filters");
      const selectedFiltersH = document.querySelector(".selected-filters")?.clientHeight || 0;
      const secondFiltersH = document.querySelector(".second-search-bar")?.clientHeight || 0;
      let top = mainFilters.clientHeight + selectedFiltersH + 20;

      const leftFilters = document.querySelector(".vertical-filters-mode");
      if (!leftFilters) {
        top += secondFiltersH
      }
      collapseBtn.style.top = top + "px";
    },
    hasTourImages(url) {
      return url?.includes("tours")
    },
    serviceClick(item) {
      if (item[0].SvKey === 14 && this.settings.UseBusSeatChecks !== 0) {
        const busInfo = item.map(x => {
          x.code = x.BusTransfer.Key;
          x.transportKey = x.BusTransferDetails[0].Transport.Key;
          return x
        });

        this.rigthModalType = 'bus';
        this.transportInfo = [...busInfo];
        this.showRightModal = true
      } else if (item[0].SvKey === 15 && this.settings.UseRwtSeatChecks !== 0) {
        const railwayInfo = item.map(x => {
          x.code = x.RailwayTransfer.Key;
          x.transportKey = x.RailwayTransferDetails[0].Transport.Key;
          return x
        });

        this.rigthModalType = 'railway';
        this.transportInfo = [...railwayInfo];
        this.showRightModal = true
      } else if (item[0].SvKey === 2 && item[0].Details[0].IsShowTransportPlan && this.settings.UseTransferSeatChecks !== 0) {
        const transferInfo = item.map(x => {
          x.code = x.Code.Key;
          x.transportKey = x.Details[0].SubCode1.Key;
          return x
        });

        this.rigthModalType = 'transfer';
        this.transportInfo = [...transferInfo];
        this.showRightModal = true
      }
    },
    getQuotaTextOfServices(service) {
      const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
      let helper = false;
      service.forEach(x => {
        if (!quotaServices.includes(x.SvKey)) {
          helper = true
        }
      });
      if (helper) return "";

      let res = "";
      let priority = 4;
      service.forEach(x => {
        const details = x.Details || x.BusTransferDetails;
        const quota = details[0].QuotaStatus;

        if (quota.PlacesStatus === 4 && priority >= 1) {
          res = this.localizeList.onRequest;
          priority = 1
        } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0 && priority >= 2) {
          const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
          res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
          priority = 2;
        } else if (quota.PlacesStatus === 2 && priority === 3) {
            res = this.localizeList.quotaHasNoPlaces
        } else if (priority === 3) {
          res = this.localizeList.available
        } else if (quota.PlacesStatus === 1 && priority >= 3) {
            res = this.localizeList.available;
            priority = 3;
        } else if (quota.PlacesStatus === 2 && priority === 4) {
              res = this.localizeList.quotaHasNoPlaces
        } 
      });

      return res
    },
    showBuyListPrice(items, key) {
      return Math.floor(items.length / 2) === key
    },
    getCurrencyDisplayBySettings(rate){
      return this.$store.getters['getCurrencyDisplayBySettings'](rate);
    },
    getCOInfo(hotels) {
      const COKeys = [];
      hotels.forEach(x => {
        if (x.COAndSpecialsInfo.AppliedCostOffersKeys) {
          x.COAndSpecialsInfo.AppliedCostOffersKeys.forEach(x2 => {
            COKeys.push(x2)
          })
        }
      });

      if (!COKeys.length) return;

      this.$store.dispatch('hotels/A_GET_CO_INFO', COKeys)
        .then(res => {
          this.COInfo = res.data
        })
    },
    correctDurationNight(n) {
      if (n <= 1)
        return n +" "+ this.localizeList.night;
      else if (n < 5)
        return  n +" "+ this.localizeList.night2;
      else
        return  n +" "+ this.localizeList.nights;
    },
    keydown(e) {
      if (this.showRightModal && this.rigthModalType === 'hotelInfo') {

        if (e.keyCode === 13) {
          e.preventDefault();

          if (this.focusHotelVariantBtn !== null) {
            const key = this.focusHotelVariantBtn;
            const item = this.buyList[this.hotelInfo.key][key];

            this.buyTour(item, key)
          }
        }
        if (e.keyCode === 9) {
          e.preventDefault();

          const variantLength = this.buyList[this.hotelInfo.key].length;
          const navLength = this.hotelInfo.nav.length;
          let index = this.hotelInfo.activeItem ;
          if (index === -1) {
            if (this.focusHotelVariantBtn === null) {
              this.focusHotelVariantBtn = 0
            } else {
              this.focusHotelVariantBtn++;
            }

            if (this.focusHotelVariantBtn === variantLength) {
              this.focusHotelVariantBtn = null;
              index++
            }
          } else {
            index++
          }
          if (navLength === index) index = -1;

          this.changeHotelInfoNavbar(index);
        }
      }
    },
    getMapItems() {
      setTimeout(() => {
        this.$store.dispatch('hotels/A_GET_HOTELS_FOR_MAP')
      },0);
    },
    showPopover(text, e, nowrap = true) {
      let rect = e.target.getBoundingClientRect()
      let res = {
        x: rect.left + (rect.width / 2),
        y: rect.top,
        text: text,
        height: rect.height,
        nowrap
      };
      this.$store.dispatch(typesGlobal.A_SHOW_POPOVER, res)
    },
    toggleBuyList(key, item, onlyList = false) {
      if (this.listType === 'map') {
        this.focusedMapItem = item
      }
      if (!this.hasHotel(item)) {
        this.buyTourMinPrice(item, 0);
        if (this.listType === 'grid') this.buyListNotHotelKeyForCard = key;
        if (this.listType === 'row') this.buyListNotHotelKeyForRow = key;
        if (this.listType === 'big-row') this.buyListNotHotelKeyForBigRow = key;
        return
      }
      item.rateCode = this.rate.Code;
      this.$store.dispatch("hotels/" + typesHotels.A_SET_HOTEL_DETAILS, item)
        .then(res => {
          // Google Tag Manager
          if (!this.buyListShow[key]) {
            let urlCurrency = this.$route.fullPath.split('currency=')[1];
            urlCurrency = urlCurrency ? urlCurrency.split('&')[0] : urlCurrency;
            urlCurrency = urlCurrency ? urlCurrency.split('?')[0] : urlCurrency;

            GTM.tourVariantsShow(item, key, urlCurrency);
          }
          // End Google Tag Manager

          if (!res.data.Result.length) {
            this.buyTourMinPriceAndHotelSchem(item, 0);
            return
          }
          let list = [];
          res.data.Result[0].RouteSubVariants.forEach(x => {
            let hotelData = x.Services.filter(x2 => x2.SvKey === 3).map(x2 => x2.HotelDetails[0]);
            let items = [];
            hotelData.forEach(x2 => {
              items.push({
                adult: x2.Room.Value,
                roomCategory: x2.RoomCategory.Value,
                accomodationType: x2.AccomodationType.Value,
                pansion: x2.Pansion.Value,
                pansionAdditionalInfo: x2.PansionAdditionalInfo,
                criticalInfo: x2.CriticalInfo,
                quotaStatus: x2.QuotaStatus,
                hotelData: x2,
              });
            });
            list.push({
              items,
              price: x.Price,
              penalties: x.Penalties,
              cost: x.Cost,
              allData: res.data.Result[0],
              hotelScheme: x.CostServicesComposition[0]
            });
          });
          // this.sortHotelRooms(list);

          this.$set(this.buyList, key, list);
          if (!onlyList) {
            this.$set(this.buyListShow, key, !this.buyListShow[key]);
          }
        })
    },
    // sortHotelRooms(list) {
    //   list.sort((a, b) => {
    //     if (a.cost > b.cost) {
    //       return 1
    //     } else if (a.cost < b.cost) {
    //       return -1
    //     } else {
    //       const room1 = this.getHotelRoomInfo(a.items[0]);
    //       const room2 = this.getHotelRoomInfo(b.items[0]);
    //       return room1 > room2 ? 1 : room1 < room2 ? -1 : 0
    //     }
    //   });
    // },
    getHotelRoomInfo(item) {
      return item.accomodationType + " / " + item.roomCategory + " / " + item.adult
    },
    hoverList(key) {
      this.$set(this.buyListHover, key, true);
    },
    leaveList(key) {
      this.$set(this.buyListHover, key, false);
    },
    windowClick() {
      this.tourResultList.forEach((x, i) => {
        if (!this.buyListHover[i]) {
          this.$set(this.buyListShow, i, false);
        }
        if (this.tourResultList.length === 1) {
          this.$set(this.buyListShow, i, this.buyListShow[i]);
        }
        if (!x.hoverHotelsList) {
          x.showHotelsList = false
        }
      })
    },
    loadMoreLocalOrExternal(isLocal, page) {
      if (isLocal && this.stopLoadMoreLocalResult || !isLocal && this.stopLoadMoreExternalResult) return;

      this.moreResultLoader = true;
      this.$store.dispatch("hotels/A_GET_NEXT_PAGE", { isLocal, page, loadAll: false })
        .then(res => {
          const resultLength = res.data.Result?.length || res.data.SearchForMap?.length;
          if (!resultLength || resultLength < 20) {
            if (isLocal) {
              this.stopLoadMoreLocalResult = true;
            } else {
              this.stopLoadMoreExternalResult = true;
            }
          }

          if (isLocal) {
            console.log("localQueries:", page);
          } else {
            console.log("remoteQueries:", page);
          }
          this.moreResultLoader = false;
        })
    },
    loadMore() {
      this.moreResultLoader = true;
      this.resultPage++;
      const page = this.resultPage;
      this.$store.dispatch("hotels/A_GET_NEXT_PAGE", { isLocal: false, page, loadAll: true })
        .then(res => {
          const resultLength = res.data.Result?.length || res.data.SearchForMap?.length;
          if (!resultLength || resultLength < 20) {
            this.stopLoadMoreResult = true;
          }
          this.moreResultLoader = false;
        })
    },
    getQuotaText(item, svKey) {
      const quotaServices = this.$store.getters['getQuotaServices'].map(x => x.Key);
      if (!quotaServices.includes(svKey)) {
        return ""
      }

      const quota = item.quotaStatus || item.QuotaStatus;
      let res = null;
      if (quota.PlacesStatus === 4) {
        res = this.localizeList.onRequest
      } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
        const placesLeft = quota.FreePlaces === 1 ? 'placesLeft1' : (quota.FreePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
        res = this.localizeList[placesLeft].replace("{}", quota.FreePlaces);
      } else if (quota.PlacesStatus === 2) {
          res = this.localizeList.quotaHasNoPlaces
      } else {
        res = this.localizeList.available
      }
      return res
    },
    getBuyIconStatus(item) {
      const quota = item.quotaStatus || item.QuotaStatus;
      if (quota.PlacesStatus === 1 && quota.FreePlaces === 0) {
        return "aviailable"
      } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
        return "less"
      } else if (quota.PlacesStatus === 4) {
        return "request"
      } else if (quota.PlacesStatus === 2) {
          return "not-aviailable"
      }
    },
    getHotelName(item, ofRightModal = false) {
      let hotel = item.Services.filter(x => x.SvKey === 3);
      const index = ofRightModal ? this.hotelInfo.hotelIndex : 0;

      if (!hotel.length) return "";

      return hotel[index].Hotel.Value;
    },
    getHotelStars(item, ofRightModalHeader = false, ofRightModalList = false) {
      let res = 0;

      if (ofRightModalList) {
        res = this.getStars(item) ? this.getStars(item) : item;

        return res;
      }

      let hotel = item.Services.filter(x => x.SvKey === 3);
      const index = ofRightModalHeader ? this.hotelInfo.hotelIndex : 0;

      if (!hotel.length) return "";

      res = this.getStars(hotel[index].Stars.Value) ? this.getStars(hotel[index].Stars.Value) : hotel[index].Stars.Value;

      return res;
    },
    getStars(val) {
      if (!val) {
        return val
      }
      let res = 0;
      let stars = parseInt(val[0]);
      if (typeof stars === "number" && !isNaN(stars)) {
        res = stars
      }
      return res
    },
    getHotelCity(item, ofRightModal = false) {
      const hotel = item.Services.filter(x => x.SvKey === 3);
      const index = ofRightModal ? this.hotelInfo.hotelIndex : 0;

      if (!hotel.length) return "";

      return hotel[index].City.Value;
    },
    getHotelCountry(item, ofRightModal = false) {
      const hotel = item.Services.filter(x => x.SvKey === 3);
      const index = ofRightModal ? this.hotelInfo.hotelIndex : 0;

      return hotel[index].Country.Value;
    },
    getHotelTimeInfo() {
      const checkInAt = this.localizeList.checkInAt;
      const checkOutBefore = this.localizeList.checkOutBefore;
      const checkInAtTime = this.hotelInfo.timeFrom;
      const checkOutBeforeTime = this.hotelInfo.timeTo;

      if (!checkInAtTime || !checkOutBeforeTime) return "";

      return `${checkInAt} ${checkInAtTime}, ${checkOutBefore} ${checkOutBeforeTime}.`
    },
    getDepartureCity(item) {
      return item.CityDepature.Value;
    },
    getHotelType(item, ofRightModal = false) {
      const hotel = item.Services.filter(x => x.SvKey === 3);
      const index = ofRightModal ? this.hotelInfo.hotelIndex : 0;

      if (!hotel.length) return "";

      return hotel[index].HotelTypes;
    },
    getHotelTypeIcon(key) {
      let path = this.$store.getters['getPath'];
      return `${this.$store.getters['getApiOrigin']}${path}/GetImage/GetImage?type=hotelType&id=${key}&width=20&height=20`
    },
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
    getHotelMainImg(hotelKeys) {
      let date = new Date().getTime();

      let hotelKeysUnicue = hotelKeys.flat(1).map(x => `HotelKeys=${x}`);
      hotelKeysUnicue = Array.from(new Set(hotelKeysUnicue));
      hotelKeysUnicue = this.sliceIntoChunks(hotelKeysUnicue, 50);

      const getHotelImages = [];
      hotelKeysUnicue.forEach(x => {
        getHotelImages.push(new Promise(resolve => {
          Vue.Api.Get(this.$store.getters['getApiUrl'] + `HotelImages?${x.join("&")}&_=` + date)
            .then(res => {
              resolve(res.data)
            });
        }));
      })

      const tourKeys = this.tourResultList.map(x => x.Key);
      let tourKeysString = tourKeys.map(x => `TourKeys=${x}`);
      tourKeysString = new Set(tourKeysString);
      tourKeysString = Array.from(tourKeysString).join("&");

      const getTourImages = new Promise(resolve => {
        Vue.Api.Get(this.$store.getters['getApiUrl'] + `TourImages?${tourKeysString}&_=` + date)
          .then(res => {
            this.tourAllImages = res.data.Images;
            resolve(res.data.Images)
          });
      });

      Promise.all([...getHotelImages, getTourImages]).then(res => {
        let path = this.$store.getters['getPath'];

        tourKeys.forEach((x, i) => {
          const tourImage = res[res.length-1].find(x2 => x2.TourKey === x);
          const tourImageCount = res[res.length-1].filter(x2 => x2.TourKey === x).length;
          // const hotelImage = res.slice(0, res.length-1).flat(1).find(x2 => x2.HotelKey === hotelKeys[i]);
          const hotelImages = res.slice(0, res.length-1).flat(1).filter(x2 => hotelKeys[i]?.includes(x2.HotelKey));
          let url;
          if (tourImage) {
            // url = `http://supp-08//Canary//Image/GetImage?code=${x || 1}&type=small160x90&name=${tourImage.Name}&imageType=tours`;
            url = `${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${x || 1}&type=small160x90&name=${tourImage.Name}&imageType=tours`;

            this.$set(this.sliderDefaultImage, i, url);
            this.$set(this.sliderDefaultImageCount, i, tourImageCount);

            this.$set(this.sliderDefaultImageForRowResult, i, [url]);
          } else if (hotelImages?.length) {
            // url = `http://supp-08//Canary//Image/GetImage?code=${hotelKeys[i][0] || 1}&type=small160x90&name=${hotelImages[0].Name}&imageType=hotels`;
            url = `${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${hotelKeys[i][0] || 1}&type=small160x90&name=${hotelImages[0].Name}&imageType=hotels`;

            this.$set(this.sliderDefaultImage, i, url);
            this.$set(this.sliderDefaultImageCount, i, hotelImages[0].ImagesCount);

            const urls = []
            hotelImages.forEach((x, i2) => {
              urls.push(`${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${hotelKeys[i][i2] || 1}&type=small160x90&name=${x.Name}&imageType=hotels`)
            })
            this.$set(this.sliderDefaultImageForRowResult, i, urls);
          } else {
            // url = `http://supp-08//Canary//Image/GetImage?code=${hotelKeys[i] || 1}&type=small160x90&name=null&imageType=hotels`;
            url = `${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${hotelKeys[i] || 1}&type=small160x90&name=null&imageType=hotels`;

            this.$set(this.sliderDefaultImage, i, url);
            this.$set(this.sliderDefaultImageCount, i, 0);

            this.$set(this.sliderDefaultImageForRowResult, i, [url]);
          }
        })
      })
    },
    rightModalBooking(html, item, key) {
      if (!html && !this.hasTourImages(this.sliderDefaultImage[key])) return;
      this.showRightModal = true;
      this.rigthModalType = "tourBooking";
      this.selectedTourName = item.Name;
      this.tourBookingHTML = html;

      this.tourImages = [];
      this.tourImagesDescription = [];

      const imagesData = this.tourAllImages.filter(x => x.TourKey === item.Key);
      let path = this.$store.getters['getPath'];
      imagesData.forEach(x => {
        this.tourImagesDescription.push(x.Description);
        this.tourImages.push(`${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${x.TourKey ? x.TourKey : 639}&type=small160x90&name=${x.Name}&imageType=tours`)
      });
    },
    rightModalAviaFlight(item) {
      this.aviaFlightInfo.services = [];
      this.rigthModalType = "aviaFlight";
      this.showRightModal = true;
      this.aviaFlightInfo.data = item;
      item.Services.forEach((x) => {
        if (x.SvKey === 1) {
          if (!this.aviaFlightInfo.services.length) {
            this.aviaFlightInfo.services.push([x])
          } else {
            if (x.FlightSetting.ServiceId === this.aviaFlightInfo.services[0][0].FlightSetting.ServiceId) {
              this.aviaFlightInfo.services[0].push(x)
            } else {
              if (!this.aviaFlightInfo.services[1]) {
                this.aviaFlightInfo.services.push([x])
              } else {
                this.aviaFlightInfo.services[1].push(x)
              }
            }
          }
        }
      });
    },
    hasHotel(item) {
      return item.Services.some(x => x.SvKey === 3);
    },
    hideHotelsList() {
      this.tourResultList.forEach(x => {
        x.showHotelsList = false
      })
    },
    rightModalHotelOrTourInfo(item, key, e) {
      if (e.imageType === "tour") {
        this.rightModalBooking(item.BookingConditions, item, key)
      } else {
        this.rightModalHotelInfo(item, key)
      }
    },
    rightModalHotelInfo(item, key, index = 0, scrollToMap = false) {
      const hasHotel = this.hasHotel(item);
      if (!hasHotel) {
        return
      }
      this.getMapItems();

      setTimeout(() => {
        let top = 0;
        if (scrollToMap) {
          top = this.$refs.hotelMap[0].offsetTop - this.$refs.hotelInfoContent.offsetTop;
        }
        this.$refs.hotelInfoContent.scrollTo({
          top,
          behavior: scrollToMap ? "smooth" : "auto"
        });

      }, (scrollToMap ? 1000 : 0));
      this.hideHotelsList();
      this.toggleBuyList(key, item, true);
      this.showRightModal = true;
      this.rigthModalType = "hotelInfo";
      this.hotelInfo.data = item;
      this.hotelInfo.hotelIndex = index;
      this.hotelInfo.key = key;

      const hotels = item.Services.filter(x => x.SvKey === 3);
      const hasCoord = hotels[index].Latitude && hotels[index].Longitude;
      this.tourResultList[key].coordinates = hasCoord ? [
        parseFloat(hotels[index].Latitude), 
        parseFloat(hotels[index].Longitude)
      ] : [];

      this.getHotelImages(item)
        .then(res => {
          this.hotelInfo.http = res.data.Http;
          this.hotelInfo.hasImages = res.data.HasImages;
          this.hotelInfo.nav = [this.localizeList.photoUpper];
          this.hotelInfo.moreInfo = []
          if (res.data.Description) {
            this.hotelInfo.nav.push(this.localizeList.hotelDescriptionUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.hotelDescriptionUpper,
              value: res.data.Description
            });
          }
          if (res.data.InfrastructureHotel) {
            this.hotelInfo.nav.push(this.localizeList.infrastructureHotelUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.infrastructureHotelUpper,
              value: res.data.InfrastructureHotel
            });
          }
          if (res.data.RecreationSport) {
            this.hotelInfo.nav.push(this.localizeList.recreationSportUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.recreationSportUpper,
              value: res.data.RecreationSport
            });
          }
          if (res.data.Beach) {
            this.hotelInfo.nav.push(this.localizeList.beachUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.beachUpper,
              value: res.data.Beach
            });
          }
          if (res.data.Healing) {
            this.hotelInfo.nav.push(this.localizeList.healingUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.healingUpper,
              value: res.data.Healing
            });
          }
          if (res.data.AdditionalService) {
            this.hotelInfo.nav.push(this.localizeList.additionalServicesUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.additionalServicesUpper,
              value: res.data.AdditionalService
            });
          }
          if (res.data.ForChildren) {
            this.hotelInfo.nav.push(this.localizeList.forChildrensUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.forChildrensUpper,
              value: res.data.ForChildren
            });
          }
          if (res.data.Excursion) {
            this.hotelInfo.nav.push(this.localizeList.excursionsUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.excursionsUpper,
              value: res.data.Excursion
            });
          }
          if (res.data.AddCost) {
            this.hotelInfo.nav.push(this.localizeList.addCostUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.addCostUpper,
              value: res.data.AddCost
            });
          }
          if (res.data.Address || res.data.Phone || res.data.Email) {
            this.hotelInfo.nav.push(this.localizeList.contactsUpper);
            this.hotelInfo.moreInfo.push({
              title: this.localizeList.contactsUpper,
              isContact: true,
              address: res.data.Address || null,
              phone: res.data.Phone || null,
              email: res.data.Email || null,
            });
          }

          this.hotelInfo.timeFrom = res.data.CheckoutTimeFrom;
          this.hotelInfo.timeTo = res.data.CheckoutTimeTo;
          this.hotelInfo.images = res.images;
          this.hotelInfo.imagesDescription = res.data.Images.map(x => x.Description);

          if (item) {
            this.$nextTick(() => {
              this.focusedMapItemInHotelInfo = item;
              this.focusedMapHotelInListView = item.Services.filter(x => x.SvKey === 3)[index];
            })
          }
        })
    },
    getHotelImages(item) {
      return new Promise((resolve) => {
        let key = null;
        item.Services
          .filter(x => x.SvKey === 3)
          .forEach((x, i) => {
            if (i === this.hotelInfo.hotelIndex) {
              key = x.Hotel.Key
            }
          });

        let date = new Date().getTime();
        Vue.Api.Get(this.$store.getters['getApiUrl'] + `HotelImages?HotelKey=${key ? key : 639}&_=` + date)
          .then(res => {
            let imagesData = res.data.Images || [];
            let images = [];
            let path = this.$store.getters['getPath'];
            imagesData.forEach(x => {
              images.push(`${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${x.HotelKey ? x.HotelKey : 639}&type=small160x90&name=${x.Name}&imageType=hotels`)
            });
            resolve({
              data: res.data,
              images
            })
          });
      });
    },
    changeHotelInfoNavbar(key) {
      this.clickBeforeScroll = true;
      this.hotelInfoScrollTimer = new Date().getTime();

      if (key === -1) {
        this.hotelInfo.activeItem = -1;

        this.$refs.hotelInfoContent.scrollTo({
          top: this.$refs.hotelVariants.offsetTop - this.$refs.hotelInfoContent.offsetTop + 1,
          behavior: "smooth"
        });
        return
      }
      this.hotelInfo.activeItem = key;
      let to = key ? this.$refs.hotelInfoItem[key - 1].offsetTop - this.$refs.hotelInfoContent.offsetTop : key;

      this.$refs.hotelInfoContent.scrollTo({
        top: to + 1,
        behavior: "smooth"
      })
    },
    buyTourMinPrice(item) {
      const href = window.location.href.split("&");
      let currency =
        this.$store.getters['getAllCurrency'].find(x => x.Code === item.Rate);

      currency = currency.IsoCode;
      const tourKey = item.Key;
      const dCity = item.CityDepature.Key;
      const aCountry = item.CountryId;
      let date = item.StartDate.split("T")[0].split("-").reverse();
      date[2] = date[2].slice(2);
      date = date.join(".");
      const duration = +item.DurationInNight + 1;

      const adultCount = href.find(x => x.includes("adultCount")).split("=")[1];
      let childAges = href.find(x => x.includes("childAges"));
      childAges = childAges ? childAges.split("=")[1] : childAges;

      const aviaQuota = href.find(x => x.includes("aviaQuota"));
      const hotelQuota = href.find(x => x.includes("hotelQuota"));
      const busTransferQuota = href.find(x => x.includes("busTransferQuota"));
      const railwayTransferQuota = href.find(x => x.includes("trainTransferQuota"));

      let serviceDescriptions = item.MinCostServicesComposition.map(x => {
        let res = [];

        Object.values(x.Key).forEach(x2 => res.push(x2))
        res.push(x.Value.ServiceType)
        res.push(x.Value.Code)
        res.push(x.Value.SubCode1);
        res.push(x.Value.SubCode2)
        res.push(x.Value.CountryId)
        res.push(x.Value.CityId)
        res.push(x.Value.PacketId)
        res.push(x.Value.PartnerId)
        res.push(x.Value.Day)
        res.push(x.Value.DurationInNight)
        return res.join("_")
      })

      let newUrl = `Individuals/Hotels/Basket?departureCities=${dCity}` +
        `&destination=1_${aCountry}` +
        `&tour=${tourKey}` +
        `&date=${date}` +
        `&duration=${duration}` +
        `&hotelScheme=` +
        `&adultCount=${adultCount}` +
        (childAges ? `&childAges=${childAges}` : "") +
        `&${hotelQuota}&${aviaQuota}&${busTransferQuota}&${railwayTransferQuota}` +
        `&serviceDescriptions=${serviceDescriptions.join(",")}` +
        `&currency=${currency}`

      let beforeHash = window.location.href.split("#")[0];
      beforeHash = beforeHash + "#/" + newUrl;
      this.cashSearchHref();

      // const touristCount = +adultCount + (childAges ? childAges.split(",").length : 0);

      // Google Tag Manager
      // const searchCurrency = href.find(x => x.includes("currency=")).split("=")[1];
      // GTM.toBasket({allData: item}, key, touristCount, searchCurrency);
      // sessionStorage.setItem("GTM_from_search", "true");
      // End Google Tag Manager

      // if (this.$route.params.searchParams !== beforeHash)
      //     window.location.href = beforeHash
      window.open(beforeHash)
    },
    buyTourMinPriceAndHotelSchem(item) {
      const href = window.location.href.split("&");
      let currency =
        this.$store.getters['getAllCurrency'].find(x => x.Code === item.Rate);

      currency = currency.IsoCode;
      const tourKey = item.Key;
      const dCity = item.CityDepature.Key;
      const aCountry = item.CountryId;
      let date = item.StartDate.split("T")[0].split("-").reverse();
      date[2] = date[2].slice(2);
      date = date.join(".");
      const duration = +item.DurationInNight + 1;

      let hotelScheme = "";
      item.MinCostServicesComposition.forEach((x) => {
        if (x.Value.ServiceType === 3) {
          const templateId = x.Key.TemplateId;
          const durationInNight = x.Value.DurationInNight;
          const code = x.Value.Code;
          const packetId = x.Value.PacketId;
          const partnerId = x.Value.PartnerId;
          const GDSProviderId = 0;
          const duration = item.Duration;
          hotelScheme += (hotelScheme.length ? "," : "") + `${templateId}_${durationInNight}_${code}_${packetId}_${partnerId}_${GDSProviderId}_${duration}`;
        }
      });

      const adultCount = href.find(x => x.includes("adultCount")).split("=")[1];
      let childAges = href.find(x => x.includes("childAges"));
      childAges = childAges ? childAges.split("=")[1] : childAges;

      const aviaQuota = href.find(x => x.includes("aviaQuota"));
      const hotelQuota = href.find(x => x.includes("hotelQuota"));
      const busTransferQuota = href.find(x => x.includes("busTransferQuota"));
      const railwayTransferQuota = href.find(x => x.includes("trainTransferQuota"));

      let serviceDescriptions = item.MinCostServicesComposition.map(x => {
        let res = [];

        Object.values(x.Key).forEach(x2 => res.push(x2))
        res.push(x.Value.ServiceType)
        res.push(x.Value.Code)
        res.push(x.Value.SubCode1);
        res.push(x.Value.SubCode2)
        res.push(x.Value.CountryId)
        res.push(x.Value.CityId)
        res.push(x.Value.PacketId)
        res.push(x.Value.PartnerId)
        res.push(x.Value.Day)
        res.push(x.Value.DurationInNight)
        return res.join("_")
      })

      const hotel = item.Services.find(x => x.SvKey === 3);
      const pansionAdditionalInfo = hotel?.HotelDetails[0].PansionAdditionalInfo
      const criticalInfo = hotel?.HotelDetails[0].criticalInfo
      let newUrl = `Individuals/Hotels/Basket?departureCities=${dCity}` +
        `&destination=1_${aCountry}` +
        `&tour=${tourKey}` +
        `&date=${date}` +
        `&duration=${duration}` +
        `&hotelScheme=${hotelScheme}` +
        `&adultCount=${adultCount}` +
        (childAges ? `&childAges=${childAges}` : "") +
        `&${hotelQuota}&${aviaQuota}&${busTransferQuota}&${railwayTransferQuota}` +
        `&serviceDescriptions=${serviceDescriptions.join(",")}` +
        (pansionAdditionalInfo ? `&pansionAdditionalInfo=${pansionAdditionalInfo.replaceAll("%", "percent")}` : '') +
        (criticalInfo ? `&criticalInfo=${criticalInfo.replaceAll("%", "percent")}` : '') +
        `&currency=${currency}`

      let beforeHash = window.location.href.split("#")[0];
      beforeHash = beforeHash + "#/" + newUrl;
      this.cashSearchHref();

      // const touristCount = +adultCount + (childAges ? childAges.split(",").length : 0);
      // Google Tag Manager
      // const searchCurrency = href.find(x => x.includes("currency=")).split("=")[1];
      // GTM.toBasket({allData: item}, key, touristCount, searchCurrency);
      // sessionStorage.setItem("GTM_from_search", "true");
      // End Google Tag Manager

      // if (this.$route.params.searchParams !== beforeHash)
      //     window.location.href = beforeHash
      window.open(beforeHash)
    },
    buyTour(item, key) {
      const href = window.location.href.split("&");

      let currency =
        this.$store.getters['getAllCurrency'].find(x => x.Code === item.allData.Rate);

      currency = currency.IsoCode;
      const tourKey = item.allData.Key;
      const dCity = item.allData.CityDepature.Key;
      const aCountry = item.allData.CountryId;
      let date = item.allData.StartDate.split("T")[0].split("-").reverse();
      date[2] = date[2].slice(2);
      date = date.join(".");
      const duration = +item.allData.DurationInNight + 1;


      //Создаем схему отеля
      let hotelScheme = "";

      let partnerId = [];
      item.items.forEach(x => {
        partnerId.push(x.hotelData.PartnerId);
      });
      let i = 0;
      item.allData.MinCostServicesComposition.forEach((x) => {
        if (x.Value.ServiceType === 3) {
          const templateId = x.Key.TemplateId;
          const durationInNight = x.Value.DurationInNight;
          const code = x.Value.Code;
          const packetId = x.Value.PacketId;
          const GDSProviderId = x.Value.GDSProviderId ? x.Value.GDSProviderId : 0;
          const duration = item.allData.Duration;
          hotelScheme += (hotelScheme.length ? "," : "") + `${templateId}_${durationInNight}_${code}_${packetId}_${partnerId[i]}_${GDSProviderId}_${duration}`;
          i++
        }
      });

      const adultCount = href.find(x => x.includes("adultCount=")).split("=")[1];
      let childAges = href.find(x => x.includes("childAges"));
      childAges = childAges ? childAges.split("=")[1] : childAges;

      const aviaQuota = href.find(x => x.includes("aviaQuota"));
      const hotelQuota = href.find(x => x.includes("hotelQuota"));
      const busTransferQuota = href.find(x => x.includes("busTransferQuota"));
      const railwayTransferQuota = href.find(x => x.includes("trainTransferQuota"));

      let hotelRooms = item.allData.RouteSubVariants[key].Services
        .filter(x => x.SvKey === 3)
        .map(x => {
          return x.HotelDetails[0].HotelRoom
        });
      let pansionKeys = item.allData.RouteSubVariants[key].Services
        .filter(x => x.SvKey === 3)
        .map(x => {
          return x.HotelDetails[0].Pansion.Key
        });

      let hotel = 0;
      let i2 = 0;
      // let serviceDescriptions = item.allData.MinCostServicesComposition.map((x) => {
      let serviceDescriptions = item.allData.RouteSubVariants[key].CostServicesComposition.map((x) => {
        let res = [];
        Object.values(x.Key).forEach(x2 => res.push(x2))
        res.push(x.Value.ServiceType)
        res.push(x.Value.Code)
        if (x.Value.ServiceType === 3) {
          res.push(hotelRooms[hotel]);
          res.push(pansionKeys[hotel]);
          hotel++
        } else {
          res.push(x.Value.SubCode1)
          res.push(x.Value.SubCode2)
        }
        res.push(x.Value.CountryId)
        res.push(x.Value.CityId)
        res.push(x.Value.PacketId)
        if (x.Value.ServiceType === 3) {
          res.push(partnerId[i2]);
          i2++
        } else {
          res.push(x.Value.PartnerId)
        }
        res.push(x.Value.Day)
        res.push(x.Value.DurationInNight)
        return res.join("_")
      })

      const pansionAdditionalInfo = item.items[0].pansionAdditionalInfo
      const criticalInfo = item.items[0].criticalInfo
      let newUrl = `Individuals/Hotels/Basket?departureCities=${dCity}` +
        `&destination=1_${aCountry}` +
        `&tour=${tourKey}` +
        `&date=${date}` +
        `&duration=${duration}` +
        `&hotelScheme=${hotelScheme}` +
        `&adultCount=${adultCount}` +
        (childAges ? `&childAges=${childAges}` : "") +
        `&${hotelQuota}&${aviaQuota}&${busTransferQuota}&${railwayTransferQuota}` +
        `&serviceDescriptions=${serviceDescriptions.join(",")}` +
        (pansionAdditionalInfo ? `&pansionAdditionalInfo=${pansionAdditionalInfo.replaceAll("%", "percent")}` : '') +
        (criticalInfo ? `&criticalInfo=${criticalInfo.replaceAll("%", "percent")}` : '') +
        `&currency=${currency}`

      let beforeHash = window.location.href.split("#")[0];
      beforeHash = beforeHash + "#/" + newUrl;
      this.cashSearchHref();

      // const touristCount = +adultCount + (childAges ? childAges.split(",").length : 0);

      // Google Tag Manager
      // const searchCurrency = href.find(x => x.includes("currency=")).split("=")[1];
      // GTM.toBasket(item, key, touristCount, searchCurrency);
      // sessionStorage.setItem("GTM_from_search", "true");
      // End Google Tag Manager

      //if (this.$route.params.searchParams !== beforeHash)
      //   window.location.href = beforeHash
      window.open(beforeHash)
    },
    cashSearchHref() {
      const href = window.location.href;
      sessionStorage.setItem('searchHref', href);
    },
    hotelInfoContentScroll(e) {
      if (this.clickBeforeScroll) {
        const currentTime = new Date().getTime();
        if (currentTime - this.hotelInfoScrollTimer > 100) this.clickBeforeScroll = false;

        this.hotelInfoScrollTimer = new Date().getTime();
        return
      }
      const hotelInfoItems = Array.from(document.querySelectorAll(".hotel-info-content-item"));
      const hotelInfoItemsTop = hotelInfoItems.map(x => x.offsetTop);

      const scrollTop = e.target.scrollTop + e.target.offsetTop;
      this.hotelInfo.activeItem = hotelInfoItemsTop.findIndex(x => x > scrollTop);
    },
    getLocalAndRemoteHotels(arr) {
      let local = [];
      let remote = [];
      arr.forEach(x => {
        if (x.IsRemoteHotels) {
          remote.push(x)
        } else {
          local.push(x)
        }
      });

      return [local, remote]
    },
    getLocalAndRemoteHotelCount(arr) {
      let localCount = 0;
      let remoteCount = 0;
      arr.forEach(x => {
        if (x.IsRemoteHotels) {
          remoteCount++
        } else {
          localCount++
        }
      });

      return [localCount, remoteCount]
    },
    getUniqueTours(tours) {
      let makeKey = function (x) {
        return x.Name + "_" + x.StartDate + "_" + x.Duration + "_" + x.CityDepature.Key + "_" + (x.hotels && x.hotels[0] ? x.hotels[0].Hotel.Key : 0) + "_" + x.Cost;
      };
      let result = [];
      let uniqueSet = new Set();
      for (let i = 0; i < tours.length; i++) {
        let tour = tours[i];
        let key = makeKey(tour);
        if (!uniqueSet.has(key)) {
          uniqueSet.add(key);
          result.push(tour);
        }
      }

      return result;
    }
  },
  watch: {
    collapseByHotel() {
      this.resultPage = 1;
      this.localCountMax = 0;
      this.stopLoadMoreLocalResult = false;
      this.stopLoadMoreExternalResult = false;
    },
    async rigthModalType(val) {
      await this.$nextTick();

      if (val !== "hotelInfo") return;

      this.$refs.hotelInfoContent.addEventListener('scroll', this.hotelInfoContentScroll)
    },
    showRightModal(val) {
      if (!val) {
        this.focusHotelVariantBtn = null;
        this.hotelInfo.activeItem = 0;
      }
    },
    listType(val) {
      if (val === 'map') {
        this.getMapItems()
      }
    },
    tourResultList: {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        if (val.length) {
          // Google Tag Manager
          const newVal = this.gtm.firstLoad ? getArrayDifference(val, oldVal) : val;
          const localAndRemoteHotels = this.getLocalAndRemoteHotels(newVal);

          if (localAndRemoteHotels[0].length)
            GTM.sendResults(localAndRemoteHotels[0], this.gtm, val[0].rate.Code);
          if (localAndRemoteHotels[1].length)
            GTM.sendResults(localAndRemoteHotels[1], this.gtm, val[0].rate.Code);

          const localAndRemoteHotelCount = this.getLocalAndRemoteHotelCount(val);

          this.gtm.firstLoad = true;
          this.gtm.impressionsCountLocal = localAndRemoteHotelCount[0];
          this.gtm.impressionsCountRemote = localAndRemoteHotelCount[1];
          // End Google Tag Manager
        }

        if (this.listType === 'map') {
          this.getMapItems();
        }
        if (JSON.stringify(val) === this.cashTourResultList) {
          return
        }

        this.cashTourResultList = JSON.stringify(val);

        if (this.$store.getters['hotels/getSearchResult'].length) {
          this.rate = this.$store.getters['hotels/getSearchResult'][0].rate
        }
        this.stopLoadMoreResult = false;
        let keys = [];

        val.forEach((x, i) => {
          this.$set(this.buyListShow, i, false);
          this.$set(this.buyListHover, i, false);

          let hotels = x.Services.filter(x2 => x2.SvKey === 3);
          if (hotels.length) {
            const hotelKeys = hotels.map(x => x.Hotel.Key);
            keys.push(hotelKeys);
            // keys = [...keys, ...hotelKeys];
          } else {
            keys.push(null);
          }
        });
        setTimeout(() => {
          this.getHotelMainImg(keys);
        }, 0);

        if (val.length && val[0].rate) {
          this.rate = val[0].rate;
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("click", this.windowClick);
    window.removeEventListener("mouseup", this.stopDragSecondSlider);
    window.removeEventListener("keydown", this.keydown);
  },
  filters: {
    textSlice(val, numb) {
      if ((window.innerWidth > 1100 && window.innerWidth <= 1200) && val.length + numb > 25) {
        return val.slice(0, 25 - numb) + "...";
      }

      if (window.innerWidth <= 1100 && val.length + numb > 20) {
        return val.slice(0, 20 - numb) + "...";
      }

      if (val.length + numb > 30) {
        return val.slice(0, 30 - numb) + "...";
      }
      return val
    },
    correctPrice(val) {
      const isFloat = val % 1 !== 0;
      let res = new Intl.NumberFormat().format(val);

      if (res.includes(".") || !isFloat) {
        res = res.replace(/,/g, " ");
      } else {
        res = res.replace(/,/g, ".");
      }
      res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
      return res
    },
  }
}
</script>

<style scoped>
.tour-program-pansion {
  min-width: 70px;
}
.qui-quo-actions {
  margin-left: 16px;
  margin-bottom: 4px;
}
.hotels-result-content {
  padding: 18px 13px 18px;
}
.hotels-result-content.fixed-filter {
  /*padding-top: 220px;*/
}
.hotels-result-content.list-map {
  padding-left: 60px;
  padding-right: 60px;
}
.hotels-result-content.list-big-row,
.hotels-result-content.list-row {
  padding-left: 60px;
  padding-right: 60px;
  max-width: 1680px;
  margin: 0 auto;
}
.vertical-filters.hotels-result-content.list-map,
.vertical-filters.hotels-result-content.list-big-row,
.vertical-filters.hotels-result-content.list-row {
  padding-left: 16px;
}
.hotels-result-content.list-big-row .country-info,
.hotels-result-content.list-row .country-info {
  margin: 0 0 10px;
}
.hotels-result-content a {
  text-decoration: none;
}

.out-sistem-wrap {
  display: flex;
  align-items: center;
  padding: 20px 30px;
  background-color: var(--white-color);
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  z-index: 1;
}

.out-sistem-title {
  color: var(--dark-1-color);
  font-size: 20px;
  font-weight: 500;
}

.empty-result {
  font-size: 18px;
  text-align: center;
}

.list-group.map-mode {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  /*overflow: hidden;*/
}

.row-tour-result-list .hotel-list {
  bottom: 55px;
  left: unset;
  right: -8px;
  z-index: 100;
}

.row-tour-result-list .hotel-list::after {
  left: unset;
  right: 20px;
}

.hotels-result-content .tour-booking {
  width: 840px;
  height: 100%;
  overflow: auto;
  padding: 40px 72px;
}

.hotels-result-content .tour-booking .tour-booking-name {
  font-weight: 500;
  font-size: 26px;
  line-height: 30px;
  color: #1D1D1D;
}
.hotels-result-content .tour-booking .tour-booking-headline {
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: var(--lighten-5-color);
  margin-bottom: 32px;
}

/***MODAL HOTEL INFO***/
.hotels-result-content .tour-hotel-info {
  padding: 38px 0;
  min-width: 678px;
  height: 100%;
}

.hotels-result-content .tour-hotel-info .hotel-info-content {
  overflow-y: auto;
  height: calc(100vh - 170px);
  overflow-x: hidden;
  padding: 0 72px 60px;
}

.hotels-result-content .hotel-info-header {
  display: flex;
  gap: 24px;
}
.hotels-result-content .hotel-info-header .hotel-info-header-block {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.hotels-result-content .hotel-info-header .hotel-info-header-title {
  flex-grow: 1;
}
.hotels-result-content .hotel-info-header .hotel-info-header-price {
  align-items: flex-end;
}

.hotels-result-content .hotel-info-header,
.hotels-result-content .hotel-info-navbar {
  padding: 0 72px;
}

.hotels-result-content .hotel-info-navbar {
  flex-wrap: wrap;
  max-width: 824px;
}

.hotels-result-content .hotel-info-header .hotel-name {
  font-weight: 500;
  font-size: 26px;
  line-height: 30px;
  color: #1D1D1D;
}
.hotels-result-content .hotel-info-header .hotel-name a {
  color: var(--primary-color);
}

.hotels-result-content .hotel-info-header .hotel-price {
  font-weight: bold;
  font-size: 26px;
  line-height: 30px;
  color: var(--primary-color);
}

.hotels-result-content .hotel-info-header .place {
  flex-wrap: wrap;
}

.hotels-result-content .hotel-info-header .place .hotel-time-info {
  width: 100%;
  margin-left: 26px;
}

.hotels-result-content .hotel-info-navbar .nav-item {
  position: relative;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: var(--dark-1-color);
}

.hotels-result-content .hotel-info-navbar .nav-item:hover,
.hotels-result-content .hotel-info-navbar .nav-item.active {
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #E56B13;
  cursor: pointer;
  transition: all .2s;
}

.hotels-result-content .hotel-info-navbar .nav-item:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 2px;
  background-color: #FF711D;
  opacity: 0;
  transition: all .2s;
}

.hotels-result-content .hotel-info-navbar .nav-item:hover:before,
.hotels-result-content .hotel-info-navbar .nav-item.active:before {
  opacity: 1;
}

/**SLIDER**/
.hotels-result-content .hotel-info-slider {
  width: 680px;
}

.hotels-result-content .hotel-info-slider .present-slider {
  position: relative;
}

.hotels-result-content .hotel-info-slider .present-slider .slide {
  width: 680px;
  height: 380px;
  border-radius: 6px;
  background-size: 102%;
  background-repeat: no-repeat;
  background-position: 50%;
  transition: all .2s;
}

.hotels-result-content .hotel-info-slider .present-slider .slider-right-btn,
.hotels-result-content .hotel-info-slider .present-slider .slider-left-btn {
  position: absolute;
  top: 50%;
}

.hotels-result-content .hotel-info-slider .present-slider .slider-left-btn {
  left: -30px;
  transform: translateY(-50%);
}

.hotels-result-content .hotel-info-slider .present-slider .slider-right-btn {
  right: -30px;
  transform: translateY(-50%) rotate(-180deg);
}

.hotels-result-content .hotel-info-slider .second-slider {
  display: flex;
  overflow: hidden;
  width: 680px;
}

.hotels-result-content .hotel-info-slider .second-slider .second-slide {
  position: relative;
  border-radius: 6px;
  min-width: 161px;
  height: 105px;
  background-color: #ededed;
  background-size: 102%;
  background-position: 50%;
  cursor: pointer;
}

.hotels-result-content .hotel-info-slider .second-slider .second-slide:not(:last-child) {
  margin-right: 12px;
}

.hotels-result-content .hotel-info-slider .second-slider .second-slide:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0);
  transition: all .2s;
}

.hotels-result-content .hotel-info-slider .second-slider .active.second-slide:before,
.hotels-result-content .hotel-info-slider .second-slider .second-slide:hover:before {
  background-color: rgba(0, 0, 0, .3);
}

.hotels-result-content .hotel-features {
  display: flex;
  flex-wrap: wrap;
  width: 680px;
  margin-top: 26px;
  margin-bottom: 40px;
}

.hotels-result-content .hotel-features .hotel-features-item {
  margin-right: 40px;
  margin-bottom: 6px;
}

.hotels-result-content .hotel-info-content .hotel-info-content-item {
  width: 680px;
  margin-bottom: 28px;
}
.hotels-result-content .hotel-info-content .hotel-info-content-item .active {
  color: #E56B13;
}

.info-content-multi-hotels {
  display: flex;
  align-items: center;
  width: max-content;
}

.info-content-multi-hotels .info-content-link {
  display: flex;
  flex: 1 0 auto;
  width: 180px;
  align-items: center;
}

.info-content-multi-hotels .info-content-link .category-string{
  word-break: break-all;
}
.info-content-multi-hotels .link-text {
  max-width: 120px;
  text-decoration: underline;
  color: #1C88D6;
  cursor: pointer;
  flex: 0 1 auto;
  word-wrap: break-word;
}

.hotels-result-content .hotel-info-content .hotel-info-content-item .tour-program-item-group {
  border-top: 1px dashed var(--lighten-5-color);
}

.hotels-result-content .hotel-info-content .hotel-info-content-item .tour-program-item-group:last-child {
  border-bottom: 1px dashed var(--lighten-5-color);
}

.hotels-result-content .hotel-info-content .hotel-info-content-item .tour-program-item {
  /*display: flex;*/
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.hotels-result-content .hotel-info-content .hotel-info-content-item .tour-program-qui-quo-item {
  /*display: flex;*/
  display: grid;
  grid-template-columns: 1fr 1fr 80px;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.hotels-result-content .hotel-info-content .hotel-info-content-item .tour-program-item .left-block{
  width: 430px;
}

.hotels-result-content .hotel-info-content .hotel-info-content-item .tour-program-item .tour-program-list-btn {
  justify-content: space-between;
  flex-shrink: 0;
}

.hotels-result-content .more-result-loader {
  display: block;
  margin: 20px auto;
  position: relative;
  z-index: 1;
}
.hotels-result-content .load-more-btn {
  width: max-content;
  margin: 10px auto;
}

.hotels-result-content .features {
  flex-wrap: wrap;
}

.hotels-result-content .base-button {
  white-space: nowrap;
}

/deep/ .right-modal.booking {
  max-width: 50%;
}

/deep/.collapse-result-btn.base-button {
  position: sticky;
  top: 0;
  transform: rotate(-90deg);
  margin-right: 10px;
  border-radius: 50%;
  z-index: 1;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/deep/.collapse-result-btn.base-button .hover-effect {
  border-radius: 50%;
}
.collapse-result-btn.rotate {
  transform: rotate(90deg);
}
</style>
